module.exports = __webpack_public_path__ + "cc0c9e78d2ad41566d18132f0878d504.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/termine/Diskofieber.jpg
// module id = 840
// module chunks = 0